import { Outlet, useMatches } from "@remix-run/react";
import {
  Container,
  Paper,
  Text,
  Stack,
  Center,
  Box,
  Flex,
  BackgroundImage,
  alpha,
  useMantineTheme
} from '@mantine/core';
import { Logo } from "./components/dashboard/Logo";
import { LogoCelebi } from "./components/dashboard/LogoCelebi";

export default function AuthLayout() {
  const matches = useMatches();
  const theme = useMantineTheme();

  // Son match'ten background bilgisini al
  const currentMatch = matches[matches.length - 1];
  const backgroundImage = (currentMatch?.handle as { backgroundImage?: string })?.backgroundImage;

  // hubBlue tema rengini alpha ile saydam yap
  const transparentHubBlue = alpha(theme.colors.hubBlue[6], 0.8);

  const layoutContent = (
    <>
      {/* Header - 120px yüksekliğinde */}
      <Box
        pt="lg"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Logo style={{ width: 200 }} />
      </Box>

      {/* Ana içerik alanı - kalan alanı kaplar ve içeriği ortalar */}
      <Flex
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container size={360}>
          <Paper
            p="lg"
            radius="lg"
            style={{
              backgroundColor: transparentHubBlue,
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)', // Safari desteği için
            }}
          >
            <Outlet />
          </Paper>
        </Container>
      </Flex>

      {/* Footer - içeriğe göre dinamik yükseklik */}
      <Box pb="lg">
        <Stack align="center" gap="xs">
          <Text c="dimmed" size="xs">
            © {new Date().getFullYear()} Hub Desk. Tüm hakları saklıdır.
          </Text>
          <LogoCelebi style={{ width: 60 }} />
        </Stack>
      </Box>
    </>
  );

  // Eğer background image varsa BackgroundImage ile sar, yoksa normal Box kullan
  if (backgroundImage) {
    return (
      <BackgroundImage
        src={backgroundImage}
        style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
      >
        {layoutContent}
      </BackgroundImage>
    );
  }

  return (
    <Box style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {layoutContent}
    </Box>
  );
}
